export const checkPermissions = (permissions) => {
    if (permissions) {
        // console.log(JSON.stringify(permissions));
        localStorage.setItem('permissions', JSON.stringify(permissions));
        return {
            canRead: permissions.canRead === 1 ? 1 : 0,  // Returns 1 if true, otherwise 0
            canCreate: permissions.canCreate === 1 ? 1 : 0,  // Returns 1 if true, otherwise 0
            canChange: permissions.canChange === 1 ? 1 : 0,  // Returns 1 if true, otherwise 0
        };
    }
    return { canRead: 0, canCreate: 0, canChange: 0 };  // Default to 0 if no permissions are found
};

